import { render } from "./EmployerFAQ.vue?vue&type=template&id=4145d348"
import script from "./EmployerFAQ.vue?vue&type=script&lang=js"
export * from "./EmployerFAQ.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__